import { Node } from "@jsplumbtoolkit/core"


import "./InspectorPanel.scss"
import NodeModel from "../../Nodes/NodeModel"


interface Props {
    canEdit:boolean
    selectedNode?:Node
    updateNode(node:Node, originalNode?:Node, forceRedraw?:boolean):void 
    deleteNodes(nodeOrNodes:Node | Node[]):void 

}
export function InspectorPanel(props:Props) { 
    const {canEdit} = props
    // const intents = NLPModel.useState((s)=> s.intents)

    const {selectedNode, updateNode,deleteNodes} = props;
    const node:any = selectedNode?.data; 
    var nodePanel; 
    if (!node) { return null } 

        let model = NodeModel.forType(node.type)
        if (!model) { return null}
        nodePanel = <model.InspectorPanel
          node={node}
          updateNode={updateNode as any}
          deleteNode={ deleteNodes as any}
        //   intents={intents}
          canEdit={canEdit}
          
        //   {...this.props}
  
  
        //   replaceVariableNameInString={this.replaceVariableNameInString}
        //   unsetAuxPanel={this.unsetAuxPanel}
        //   hideAuxilaryPanel={this.hideAuxilaryPanel}
        //   showAuxilaryPanel={this.showAuxilaryPanel}
  
        //   navigationData={this.props.navigationData}
  
  
          />
    


    return (
        <div className={canEdit ? "InspectorPanel canEdit" : "InspectorPanel canNotEdit"}>

            {nodePanel}
        </div> 
    )
}